import api, {
	AppFormBlock as AppFormBlockProps,
	AppFormItem as AppFormItemProps,
	AppFormData,
	AppFormAction as AppFormActionProps,
} from 'api'
import AppLoading from 'components/AppLoading'
import React, { Fragment, useState, useEffect, useImperativeHandle, forwardRef } from 'react'

import { AppFormItem, AppFormTabs } from '.'
import { AppFormBlock } from './AppFormBlock'
import { AppFormContext, FormProps, initAppFormData, AppFormTabProps } from './AppFormData'
import { AppFormMenu } from './AppFormMenu'
import { GetQueryString } from 'utils'
import modelingApi from 'api/modelingApi'
import { message } from 'antd'
import { AppFormFieldData } from '../../api/index'
import Exception from 'components/Exception'
import { RouteComponentProps } from 'react-router'

export let AppForm = (props: FormProps, ref: any) => {
	const [loading, setLoading] = useState(false)
	const [formData, setFormData] = useState({ ...props.customerData })
	// const [initData] = useState( props.mode ===1? {} :  {...props.formData})
	const [appFormData, setAppFormData] = useState(initAppFormData(formData, props.appFormTabList))
	const [currTabIndex, setCurrTabIndex] = useState(props.defaultTabId)
	const [appFormTabList, setAppFormTabList] = useState(props.appFormTabList)
	const [appFormActionList, setAppFormActionList] = useState(props.appFormActionList)

	useImperativeHandle(ref, () => ({
		// 暴露给父组件的方法
		getFormData,
		getAppFormData,
		saveForm,
	}))

	const handleItemChang = (appFormItem: AppFormItemProps, value: any, label?: string) => {
		let netFormData =
			label && appFormItem.textField
				? { ...formData, [appFormItem.field]: value, [appFormItem.textField]: label }
				: { ...formData, [appFormItem.field]: value }
		setFormData(netFormData)
		setAppFormData(initAppFormData(netFormData, props.appFormTabList))
		validReq(appFormItem, netFormData)
		console.log('netFormData', netFormData)
	}

	const loadData = async () => {
		let id = GetQueryString('id')
		let apiPath = props.apiPath
		if (props.apiPath && props.apiPath !== '' && id && id !== null) {
			let data = await modelingApi.getFormData({ [props.keyName || id]: id, apiPath })
			if (data) {
				setFormData({ ...props.customerData, ...data })
			}
		}
	}

	useEffect(() => {
		loadData()
	}, [])

	const getAppFormData = () => {
		let appFormSaveData: AppFormData = {}
		// appFormSaveData = { ...props }
		appFormSaveData.fieldList = appFormData
		return appFormSaveData
	}

	const getFormData = () => {
		return formData
	}

	const validReq = (appFormItemNew?: AppFormItemProps, newFormData?: any) => {
		let flag = false
		let formDataNew = newFormData ? newFormData : formData

		let appFormTabListNew = appFormTabList.map((appFormTab: AppFormTabProps) => {
			appFormTab.appFormBlockList.map((appFormBlock: AppFormBlockProps) => {
				appFormBlock.appFormItemList &&
					appFormBlock.appFormItemList.map((appFormItem: AppFormItemProps) => {
						if (!appFormItemNew || appFormItem.field === appFormItemNew.field) {
							appFormItem.error = ''
							if (
								!appFormItem.isHidden &&
								appFormItem.req &&
								(!formDataNew[appFormItem.field] || formDataNew[appFormItem.field] === '')
							) {
								flag = true
								appFormItem.error = `请输入${appFormItem.label}`
							}
						}
						console.log('appFormItem11', appFormItem)
						return appFormItem
					})
				return appFormBlock
			})
			return appFormTab
		})
		setAppFormTabList(appFormTabListNew)
		return !flag
	}

	// 保存前操作
	const befSaveForm = () => {
		if (!validReq()) {
			return false
		}
		if (props.befSaveForm && !props.befSaveForm(getFormData(), getAppFormData())) {
			return false
		}
		return true
	}

	// 保存后操作
	const afterSaveForm = () => {
		props.afterSaveForm && props.afterSaveForm(getFormData(), getAppFormData())
		return true
	}

	const saveForm = async () => {
		let appFormSaveData = getAppFormData()
		if (!befSaveForm()) {
			return false
		}
		if (props.saveForm) {
			if (!props.saveForm(getFormData(), appFormSaveData)) return false
		} else {
			if (appFormSaveData.entity && appFormSaveData.keyName) {
				let res = await api.modeling.appform.save(appFormSaveData)
				if (res.result) {
					message.success('保存成功！')
				} else {
					message.error(res.msg)
					return false
				}
			}
		}
		afterSaveForm()
		return true
	}

	const saveFormAndClose = () => {
		if (saveForm()) {
			window.close()
		}
	}

	const renderAppFormTabs = () => {
		let isHidden = appFormTabList.length === 1 && (appFormTabList[0].title || '' === '')
		if (isHidden) return <Fragment />
		return (
			<AppFormTabs
				tabList={appFormTabList}
				defaultTabId={props.defaultTabId}
				onChange={setCurrTabIndex}
			></AppFormTabs>
		)
	}

	const renderComponent = (component: string) => {
		return ''
	}

	const renderAppForm = () => {
		if (!appFormTabList) return <Fragment />
		let { appFormBlockList, component } = appFormTabList[currTabIndex]
		if (component && component !== '') {
			return renderComponent(component)
		}
		return (
			<div className="app-form">
				{appFormBlockList.map((appFormBlockProps: AppFormBlockProps, index: number) => {
					return (
						<AppFormBlock key={index} {...appFormBlockProps}>
							{appFormBlockProps.appFormItemList &&
								appFormBlockProps.appFormItemList
									.filter(appFormItemProps => !appFormItemProps.isHidden)
									.map((appFormItemProps: AppFormItemProps) => {
										return (
											<AppFormItem
												key={appFormItemProps.field}
												{...appFormItemProps}
												value={
													formData[appFormItemProps.field] || appFormItemProps.defaultValue
												}
											/>
										)
									})}
						</AppFormBlock>
					)
				})}
			</div>
		)
	}

	const renderAppFormMenu = () => {
		if (!appFormActionList) return <Fragment />
		return (
			<AppFormMenu appFormActionList={appFormActionList} saveForm={saveForm} saveFormClose={saveFormAndClose} {...props as & RouteComponentProps<any>} />
		)
	}

	const renderLoad = () => {
		return loading ? <AppLoading /> : <Fragment />
	}

	return (
		<AppFormContext.Provider
			value={{
				formData,
				onChange: handleItemChang,
				currTabIndex,
				setCurrTabIndex,
			}}
		>
			<div className={`app-form-layout ${props.className || ''}`}>
				{renderLoad()}
				{renderAppFormTabs()}
				{renderAppForm()}
				{renderAppFormMenu()}
			</div>
		</AppFormContext.Provider>
	)
}
AppForm = forwardRef(AppForm)



// WEBPACK FOOTER //
// ./src/components/AppFormLayout/AppForm.tsx